import { IRouter } from '../router';
import { QueryParamsDictionary, UpdaterOptions } from './model';
import { encodeQueryParams } from './utils';
import { patchParams } from './updater';

export const updateQueryParams = (
  router: IRouter,
  queryParams: QueryParamsDictionary,
  update: QueryParamsDictionary,
  { updater = patchParams, historyMethod = 'push' }: UpdaterOptions = {},
) => {
  const url = new URL(router.location.href);
  url.search = encodeQueryParams(updater(queryParams, update));
  return router.navigate(url, { method: historyMethod });
};
